import './style/index.js';

import _Tabs from './tabs';

export type { TabPanelProps } from './tabPanel';
export type { TabsProps } from './tabs';

export const Tabs = _Tabs;
export default Tabs;

export * from './type';
